import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ChatOnboardingContent.css';

interface IChatOnboardingContentProps {
  minWidth?: '160px' | 'auto';
}

export const ChatOnboardingContent: React.FC<React.PropsWithChildren<IChatOnboardingContentProps>> = ({
  children,
  minWidth = 'auto',
}) => {
  return (
    <div className={styles['content']} style={{ ['--content-min-width' as string]: minWidth }}>
      <UIText2 color="text-inverted-default" whiteSpace="pre-line">
        {children}
      </UIText2>
    </div>
  );
};
